import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-9 ms-sm-auto col-lg-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "migas" }, [
  /*#__PURE__*/_createElementVNode("ol", {
    class: "breadcrumb p-3 rounded-2",
    style: {"text-decoration":"none","margin-top":"-10px!important","background":"white!important","color":"black!important"}
  }, [
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li", { class: "" }, [
      /*#__PURE__*/_createElementVNode("a", {
        style: {"text-decoration":"none","color":"#0056b3!important"},
        href: "#"
      }, " Subir Archivos / "),
      /*#__PURE__*/_createElementVNode("a")
    ])
  ])
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  id: "reportes",
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_formupload = _resolveComponent("formupload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SideBar),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_Header, { onAyosh: _ctx.logout }, null, 8, ["onAyosh"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_formupload)
          ])
        ])
      ])
    ])
  ]))
}